import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, Cell, renderPrice, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const G37Matrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>

            <Title data={Object.values(data)} title='Gables 37'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='4' content='South View' />
                        <Header colSpan='10' content='West View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='C' />
                        <Header colSpan='2' content='B1' />
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='BL' />
                        <Header colSpan='2' content='BK' />
                        <Header colSpan='2' content='BL' />
                        <Header colSpan='2' content='B' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='3/2' />
                        <Header colSpan='2' content='2/1' />
                        <Header colSpan='2' content='2/2' />
                        <Header colSpan='2' content='2/2' />
                        <Header colSpan='2' content='2/2' />
                        <Header colSpan='2' content='2/2' />
                        <Header colSpan='2' content='2/2' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='1349 sq ft' />
                        <Header colSpan='2' content='969 sq ft' />
                        <Header colSpan='2' content='1025 sq ft' />
                        <Header colSpan='2' content='1080 sq ft' />
                        <Header colSpan='2' content='1025 sq ft' />
                        <Header colSpan='2' content='1080 sq ft' />
                        <Header colSpan='2' content='1025 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>

                    {
                        range(5, 13)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={`floor-${floor}`}>
                                    {['03', '04', '02', '01', '00', '08', '09'].map(unit_num => (
                                        <Cell
                                            key={`${floor}${unit_num}`}
                                            unit={`${floor}${unit_num}`}
                                            price={renderPrice(data[`01-${floor}${unit_num}`], matrixType)}
                                            status={data[`01-${floor}${unit_num}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))
                    }


                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />
            <Title title='Gables 37'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='4' content='North View' />
                        <Header colSpan='12' content='East View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='C' />
                        <Header colSpan='2' content='B1' />
                        <Header colSpan='2' content='D' />
                        <Header colSpan='2' content='B1' />
                        <Header colSpan='2' content='A' />
                        <Header colSpan='2' content='A' />
                        <Header colSpan='2' content='B2' />
                        <Header colSpan='2' content='D' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='3/2' />
                        <Header colSpan='2' content='2/1' />
                        <Header colSpan='2' content='2/2' />
                        <Header colSpan='2' content='2/1' />
                        <Header colSpan='2' content='1/1' />
                        <Header colSpan='2' content='1/1' />
                        <Header colSpan='2' content='2/1' />
                        <Header colSpan='2' content='2/2' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='1349 sq ft' />
                        <Header colSpan='2' content='969 sq ft' />
                        <Header colSpan='2' content='1061 sq ft' />
                        <Header colSpan='2' content='930 sq ft' />
                        <Header colSpan='2' content='921 sq ft' />
                        <Header colSpan='2' content='921 sq ft' />
                        <Header colSpan='2' content='998 sq ft' />
                        <Header colSpan='2' content='1049 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>

                    {
                        range(5, 13)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={`floor-${floor}`}>
                                    {['10', '11', '12', '14', '15', '07', '06', '05'].map(unit_num => (
                                        <Cell
                                            key={`${floor}${unit_num}`}
                                            unit={`${floor}${unit_num}`}
                                            price={renderPrice(data[`01-${floor}${unit_num}`], matrixType)}
                                            status={data[`01-${floor}${unit_num}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))
                    }


                </Table.Body>
            </Table>

        </div>
    );


};

export default G37Matrix;
